import React from "react";
import { useScrollAnimation } from "../hooks/useScrollAnimation";
import "./Approach.css";

const Approach = () => {
  const [headerRef, headerVisible] = useScrollAnimation();
  const [contentRef, contentVisible] = useScrollAnimation({ threshold: 0.1 });

  const principles = [
    {
      title: "Clarity First",
      description:
        "We believe in understanding how your existing coverage works before exploring alternatives. If your current plan is the best fit, we will tell you.",
    },
    {
      title: "Efficiency Matters",
      description:
        "We focus on eliminating unnecessary costs or misaligned protection that often hides within lender-based insurance.",
    },
    {
      title: "Planning That Evolves",
      description:
        "We don't believe in 'set and forget.' We review protection as your life, income, and obligations change to ensure you are never over-insured or under-protected.",
    },
    {
      title: "The Bsquare Standard",
      description:
        "Every recommendation is backed by a structured review of your financial reality, not a sales pitch.",
    },
  ];

  return (
    <section className="approach" id="our-process">
      <div className="approach-container">
        <div ref={headerRef} className={`approach-header ${headerVisible ? "animate-in" : ""}`}>
          <h2 className="approach-title">Our Approach: The "Anti-Sales" Philosophy</h2>
          <p className="approach-intro">
            At BSquare, we don't start with a product; we start with a calculation. Our work centers on helping you make
            informed decisions aligned with your present circumstances and long-term objectives.
          </p>
        </div>
        <div ref={contentRef} className={`approach-principles ${contentVisible ? "animate-in" : ""}`}>
          {principles.map((principle, index) => (
            <div key={index} className="principle-card">
              <h3 className="principle-title">{principle.title}</h3>
              <p className="principle-description">{principle.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Approach;
